import { STATIC_COMMON_FIELDS } from '../transforms/common';
import Security from '../securities/security';

const _staticCache = new Map();

export default class StaticData {
    constructor(options) {
        this.securityManager = options.securityManager;
        this.apiManager = options.apiManager;
        this.dataPoint = Object.keys(STATIC_COMMON_FIELDS);
    }
    async staticData(params) {
        const {
            staticQueryList,
            securityMap,
            idQueryList
        } = await this._queryIdService(params);

        if (securityMap.size > 0) {
            let data = [];
            // query static data service
            if (staticQueryList.length > 0) {
                data = await this.apiManager
                    .getMarketStatic(
                        staticQueryList,
                        this.dataPoint,
                        params.method,
                        params.timeout
                    )
                    .catch(e => {
                        if (
                            params.securities.length === staticQueryList.length
                        ) {
                            throw e;
                        }
                    });
            }
            return this._staticTransforms(params.securities, securityMap, data);
        } else {
            throw this.securityManager.getInvalidSecuritiesError(idQueryList);
        }
    }
    async _queryIdService(params) {
        const idQueryList = [];
        const securityMap = new Map();
        const staticQueryList = [];
        params.securities.forEach(security => {
            if (security !== '|' && /\|/.test(security)) {
                securityMap.set(security, security);
                if (!_staticCache.has(security)) {
                    staticQueryList.push(security);
                }
            } else {
                idQueryList.push(security);
            }
        });
        // query id service for those securities don't contains secId and instruments
        if (idQueryList.length > 0) {
            const securities = await this.securityManager.create(idQueryList);
            const newStaticQueryList = [];
            securities.forEach(security => {
                if (security.isValid()) {
                    const staticQuery = `${security.securityId}|${security.quoteInstrument}`;
                    securityMap.set(security.queryKey, staticQuery);
                    if (!_staticCache.has(staticQuery)) {
                        newStaticQueryList.push(staticQuery);
                    }
                }
            });
            staticQueryList.push(...newStaticQueryList);
        }
        return {
            idQueryList,
            securityMap,
            staticQueryList
        };
    }
    _staticTransforms(securities, securityMap, marketStatic = []) {
        return securities.map(queryKey => {
            const inputKey = securityMap.get(queryKey);
            const item = {
                security: queryKey
            };
            if (inputKey) {
                if (_staticCache.has(inputKey)) {
                    item.statics = _staticCache.get(inputKey);
                } else {
                    const remoteItems = marketStatic.filter(
                        item => item.inputKey === inputKey
                    );
                    if (remoteItems.length) {
                        item.statics = remoteItems[0].statics;
                        const security = this.securityManager.getSecurities([
                            queryKey
                        ])[0];
                        if (security instanceof Security) {
                            item.statics.push(
                                {
                                    name: 'instrument',
                                    value: security.instrument
                                },
                                {
                                    name: 'quoteInstrument',
                                    value: security.quoteInstrument
                                },
                                {
                                    name: 'securityId',
                                    value: security.securityId
                                },
                                {
                                    name: 'mstarType',
                                    value: security.mstarType
                                }
                            );
                        }
                        _staticCache.set(inputKey, item.statics);
                    }
                }
            }
            return item;
        });
    }
}
